import { Fragment, useEffect, useState } from "react";
import Full from './full/Full';
import './App.scss';

function App() {
  const [isDarkMode, setIsDarkMode] = useState(false);

  useEffect(() => {
    const scrollEl = document.querySelector('.scrolling-view');
    if (!scrollEl) return;

    const onScroll = () => {
      const scrollTop = scrollEl.scrollTop;
      const viewportHeight = window.innerHeight;
      
      // .sticky-2 섹션은 sticky-1 다음에 오며, 각각 height가 설정되어 있음.
      // StickyView.js에서 height를 props로 받음.
      // Full.js에서 sticky-1의 height는 viewportHeight >= 767 ? 3000 : 1500 임.
      const sticky1Height = viewportHeight >= 767 ? 3000 : 1500;
      
      // .sticky-2가 화면에 보이기 시작하는 지점부터 색상 변경
      // 정확히는 .pathrade-link(top: 82px) 뒤가 흰색일 때 변경해야 함.
      // .sticky-2 섹션이 시작되는 scrollTop은 sticky1Height 임.
      // .sticky-2 섹션 내에서 스크롤이 진행되는 동안 흰 배경임.
      const sticky2Height = viewportHeight >= 767 ? 3000 : 1500;
      
      const linkTop = viewportHeight >= 767 ? 100 : 34;
      const startTrigger = sticky1Height - linkTop;
      const endTrigger = sticky1Height + sticky2Height - linkTop;

      if (scrollTop >= startTrigger && scrollTop <= endTrigger) {
        setIsDarkMode(true);
      } else {
        setIsDarkMode(false);
      }
    };

    scrollEl.addEventListener('scroll', onScroll);
    onScroll(); // 초기 상태 체크

    return () => {
      scrollEl.removeEventListener('scroll', onScroll);
    };
  }, []);

  return <Fragment>
        <div className='header-wrapper'>
            <div className={'header'}>
                <a href={process.env.PUBLIC_URL + "/#full-directions"}>
                    <img src={process.env.PUBLIC_URL + "/logo-uno-trading-corporation.svg"} className="logo" alt="UNO Trading Corp." />
                </a>
                <a
                    href={"https://pathrade.com"}
                    className={'pathrade-link' + (isDarkMode ? ' dark-mode' : '')}
                >
                    Go to Pathrade
                    <svg width="18" height="4" viewBox="0 0 18 4" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M0 3.34766H16L13.0909 0.347656" />
                    </svg>
                </a>
            </div>

            {/*<div className={'pathrade-link-wrapper'}>*/}
            {/*    */}
            {/*</div>*/}
        </div>
        <Full />
    </Fragment>;
}

export default App;
